"use client"

import type { SummonedUnit } from "@/types/summon.types"

interface SummonPortraitSectionProps {
  summon: SummonedUnit
  onDeselectSummon?: () => void
  scale: number
}

export const SummonPortraitSection = ({
  summon,
  onDeselectSummon,
  scale,
}: SummonPortraitSectionProps) => {
  const effectiveScale = scale > 0 ? scale : 1
  const width = 84 * effectiveScale
  const height = 84 * effectiveScale
  const left = 19 * effectiveScale
  const top = 26 * effectiveScale

  const portraitColor = summon.color || "#C0C0C0"

  return (
    <div
      id="summon-portrait-section"
      className="absolute"
      style={{
        left,
        top,
        width,
        height,
      }}
    >
      <button
        id="summon-portrait-button"
        onClick={onDeselectSummon}
        className="w-full h-full relative overflow-hidden transition-all hover:brightness-110 border-2 border-blue-500"
        title="Click to deselect summon"
      >
        {/* Portrait based on summon type */}
        <div
          className="w-full h-full flex items-center justify-center"
          style={{ backgroundColor: "#2a2a3a" }}
        >
          {/* Bramble (boar), Briar (fox), and Turret use portrait images */}
          {summon.type === "boar" ? (
            <img
              src="/images/summons/portrait-bramble.png"
              alt="Bramble"
              className="w-full h-full object-cover"
              style={{ imageRendering: "pixelated" }}
            />
          ) : summon.type === "fox" ? (
            <img
              src="/images/summons/portrait-briar.png"
              alt="Briar"
              className="w-full h-full object-cover"
              style={{ imageRendering: "pixelated" }}
            />
          ) : summon.type === "siege-tower" ? (
            <img
              src="/images/summons/portrait-turret.png"
              alt="Turret"
              className="w-full h-full object-cover"
              style={{ imageRendering: "pixelated" }}
            />
          ) : summon.type === "wolf" ? (
            <svg
              width={40 * effectiveScale}
              height={40 * effectiveScale}
              viewBox="0 0 32 32"
              fill={portraitColor}
            >
              {/* Wolf head shape */}
              <ellipse cx="16" cy="18" rx="10" ry="8" />
              <polygon points="8,14 4,6 10,12" fill={portraitColor} />
              <polygon points="24,14 28,6 22,12" fill={portraitColor} />
              <ellipse cx="20" cy="18" rx="3" ry="2" fill="#2a2a3a" />
              <circle cx="12" cy="15" r="2" fill="#ff4444" />
              <circle cx="20" cy="15" r="2" fill="#ff4444" />
            </svg>
          ) : (
            <svg
              width={40 * effectiveScale}
              height={40 * effectiveScale}
              viewBox="0 0 32 32"
              fill={portraitColor}
            >
              {/* Tower shape */}
              <rect x="8" y="8" width="16" height="20" />
              <rect x="6" y="4" width="4" height="8" />
              <rect x="12" y="4" width="4" height="8" />
              <rect x="18" y="4" width="4" height="8" />
              <rect x="22" y="4" width="4" height="8" />
              <rect x="14" y="16" width="4" height="12" fill="#2a2a3a" />
            </svg>
          )}
        </div>

        {/* Selection indicator */}
        <div className="absolute inset-0 border-2 border-blue-400 animate-pulse pointer-events-none" />
      </button>
    </div>
  )
}
